import './AboutWCPartyWittyCard.css'

export default function AboutWCPartyWittyCard({ Icon, title, subtitle }) {
  const IconEl = Icon;
  return (
    <>
      <div className='about-wc-partywitty-card-wrapper'>
        <div className='about-wc-partywitty-card-icon'>
          <IconEl />
        </div>
        <h3 className='about-wc-partywitty-card-title'>{title}</h3>
        <p className='about-wc-partywitty-card-subtitle'>{subtitle}</p>
      </div>
    </>
  )
}
